'use strict';

/*
 * Entry Observer object Constructor
 * @param {object} obj
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
Entry.Observer = /*#__PURE__*/(0, _createClass2["default"])(function Observer(_parent, object, funcName, attrs) {
  (0, _classCallCheck2["default"])(this, Observer);
  (0, _defineProperty2["default"])(this, "destroy", function () {
    var parent = this.parent;
    var index = parent.indexOf(this);
    if (index > -1) {
      parent.splice(index, 1);
    }
    return this;
  });
  this.parent = _parent;
  this.object = object;
  this.funcName = funcName;
  this.attrs = attrs;
  _parent.push(this);
});